function checkFloatValue(value, toNumber) {
    if(value !== '') {
        value = value.toString().replace(/,/g, ".").replace(/[^.\d]+/g, '').replace( /^([^\.]*\.)|\./g, '$1' )
        let number = (value.indexOf(".") >= 0) ? (value.substr(0, value.indexOf(".")) + value.substr(value.indexOf("."), toNumber + 1)) : value
        return number
    }
    return ''
}
function formatNumberPretty(value, len = 8) {
    let [left, right = ''] = value.toString().replace(/\s/g, '').split('.');

    // Обрезаем длину правой части до 8 символов
    if (right.length > len) {
        right = right.slice(0, len);
    }

    // Форматируем правую часть
    let formattedRight = right.length > 0 ? '.' + right : '';
    let formattedLeft = left.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // Удаляем ненужные нули в конце
    if (right) {
        formattedRight = formattedRight.replace(/0+$/, '');
    }

    // Собираем форматированное число
    let formattedNumber = formattedLeft + formattedRight;

    // Убедимся, что число всегда имеет две десятичные
    if (!right || right.length === 0) {
        formattedNumber += '.00';
    } else if (right.length === 1) {
        formattedNumber += '0';
    }
    if (formattedNumber.endsWith('.')) {
        formattedNumber+= '00';
    }

    return formattedNumber;
}

function formatNumber(number, fixed, withZero = true, round = false, separete = false) {

   /* if ((typeof number === 'number' || typeof number === 'string') && !isNaN(number - parseFloat(number))) {
        if(withZero)
            return Number(number).toFixed(fixed)
        number = round? Number(number).toFixed(fixed) :  String(number)
        let split = number.split('.')
        if (split.length > 1) {
            let left = split[0];
            let right = split[1].substr(0, (!fixed ? 4 : fixed))
            return Number(left + (fixed !== 0 ? '.' + right : ''))
        } else {
            return Number(number)
        }
    }*/

    if ((typeof number === 'number' || typeof number === 'string') && !isNaN(number - parseFloat(number))) {
        number = Number(number).toFixed(round? fixed : 8)
        let split = number.split('.')
        if(split.length === 1) {

            return  Number(number).toFixed(round? fixed : 8)
        }
        let left = split[0];
        let right = split[1].substr(0, (!fixed ? 4 : fixed))

        if(!separete) {
            return withZero ? left + '.' + right : Number(left + (fixed !== 0 ? '.' + right : '')).toFixed(8).replace(/\.?0+$/, '')
        }

        return withZero
            ? left.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + right
            : Number(left.replace(/\s/g, '') + (fixed !== 0 ? '.' + right : '')).toFixed(8).replace(/\.?0+$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
}

function formatDate(val) {
    const date = new Date(val * 1000);
    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)

    return `${year}-${month}-${day}`
}

function formatDateTime(val, timeZone) {
    const dateObject = new Date(val * 1000)
    return  timeZone === undefined || timeZone === null?
        dateObject.toLocaleString() :
        dateObject.toLocaleString("ru", {timeZone: timeZone})
}
export { checkFloatValue, formatNumber, formatDate, formatDateTime, formatNumberPretty }